
export class EjerlavCache {
  private static cache: { [key: string]: Promise<"string"> } = {};

  public static async get(ejerlavskode: string): Promise<string> {
    if (!this.cache[ejerlavskode]) {
      this.cache[ejerlavskode] = new Promise((resolve, reject) => {
        fetch(`https://api.dataforsyningen.dk/ejerlav/` + ejerlavskode).then((response) => {
          if (response.ok) {
            response.json().then((data) => {
              resolve(data.navn);
            });
          } else {
            reject(new Error("Failed to fetch data"));
          }
        }).catch((error) => {
          reject(error);
        });
      });
    }
    return await this.cache[ejerlavskode];
  }

}